/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  Radio,
  RadioGroupField,
  TextAreaField,
  TextField,
  Alert,
  Heading,
  Image,
  Divider,
} from "@aws-amplify/ui-react";
import { StorageManager } from "@aws-amplify/ui-react-storage";
import { Field, getOverrideProps } from "@aws-amplify/ui-react/internal";
import { PTVFastMediaUploaderTable } from "../models";
import { fetchByPath, validateField } from "./utils";
import { DataStore, Amplify, Storage } from "aws-amplify";
import awsconfig from '../aws-exports';
Amplify.configure(awsconfig);

export default function PTVFastMediaUploader(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    name: "",
    email: "",
    distributor: "",
    mediaShared: undefined,
    mediaFolder: "",
    mediaFiles: undefined,
    artist: "",
    songTitle: "",
    embargo: "",
  };
  const [successMessage, setSuccessMessage] = React.useState(false);
  const [name, setName] = React.useState(initialValues.name);
  const [email, setEmail] = React.useState(initialValues.email);
  const [distributor, setDistributor] = React.useState(
    initialValues.distributor
  );
  const [mediaShared, setMediaShared] = React.useState(
    initialValues.mediaShared
  );
  const [mediaFolder, setMediaFolder] = React.useState(
    initialValues.mediaFolder
  );
  const [mediaFiles, setMediaFiles] = React.useState(initialValues.mediaFiles);
  const [artist, setArtist] = React.useState(initialValues.artist);
  const [songTitle, setSongTitle] = React.useState(initialValues.songTitle);
  const [embargo, setEmbargo] = React.useState(initialValues.embargo);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setName(initialValues.name);
    setEmail(initialValues.email);
    setDistributor(initialValues.distributor);
    setMediaShared(initialValues.mediaShared);
    setMediaFolder(initialValues.mediaFolder);
    setMediaFiles(initialValues.mediaFiles);
    setArtist(initialValues.artist);
    setSongTitle(initialValues.songTitle);
    setEmbargo(initialValues.embargo);
    setErrors({});
  };
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const [resetFile, setResetFile] = React.useState(1);
  const resetFiles = () => {
    setResetFile(Math.random());
  }
  const validations = {
    name: [{ type: "Required" }],
    email: [{ type: "Required" }, { type: "Email" }],
    distributor: [{ type: "Required" }],
    mediaShared: [],
    mediaFolder: [{ type: "URL" }],
    mediaFiles: [],
    artist: [],
    songTitle: [],
    embargo: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  const processFile = async ({ file }) => {
    const fileExtension = file.name.split('.').pop();

    return file
      .arrayBuffer()
      .then((filebuffer) => window.crypto.subtle.digest('SHA-1', filebuffer))
      .then((hashBuffer) => {
        return { file, key: (Math.random() + 1).toString(36).substring(7) + '_' + file.name };
      });
  };


  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      width="47rem"
      marginLeft="auto"
      marginRight="auto"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          name,
          email,
          distributor,
          mediaShared,
          mediaFolder,
          mediaFiles,
          artist,
          songTitle,
          embargo,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new PTVFastMediaUploaderTable(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
          setSuccessMessage(true);
          resetFiles();
          goToTop();
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "PTVFastMediaUploader")}
      {...rest}
    >
      <Image
        alt="Pedestrian TV"
        src="/ptv-logo.webp"
        width="40%"
        marginLeft="auto"
        marginRight="auto"
      />
      <Divider marginBottom="20px" />
      <Heading level={3}>PEDESTRIAN TELEVISION Media Uploader</Heading>
      {successMessage && (
        <>
          <Alert
            isDismissible={false}
            hasIcon={true}
            heading="Thanks for your submission!"
            variation="success"
          >
            We have received your completed form for consideration on PEDESTRIAN TELEVISION.
          </Alert>

        </>

      )}
      <TextField
        label={
          <span style={{ display: "inline-flex" }}>
            <span>Your Name</span>
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        value={name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name: value,
              email,
              distributor,
              mediaShared,
              mediaFolder,
              mediaFiles,
              artist,
              songTitle,
              embargo,
            };
            const result = onChange(modelFields);
            value = result?.name ?? value;
          }
          if (errors.name?.hasError) {
            runValidationTasks("name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("name", name)}
        errorMessage={errors.name?.errorMessage}
        hasError={errors.name?.hasError}
        {...getOverrideProps(overrides, "name")}
      ></TextField>
      <TextField
        label={
          <span style={{ display: "inline-flex" }}>
            <span>Your Email</span>
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        value={email}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              email: value,
              distributor,
              mediaShared,
              mediaFolder,
              mediaFiles,
              artist,
              songTitle,
              embargo,
            };
            const result = onChange(modelFields);
            value = result?.email ?? value;
          }
          if (errors.email?.hasError) {
            runValidationTasks("email", value);
          }
          setEmail(value);
        }}
        onBlur={() => runValidationTasks("email", email)}
        errorMessage={errors.email?.errorMessage}
        hasError={errors.email?.hasError}
        {...getOverrideProps(overrides, "email")}
      ></TextField>
      <TextField
        label={
          <span style={{ display: "inline-flex" }}>
            <span>Record Label or Distributor</span>
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        value={distributor}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              email,
              distributor: value,
              mediaShared,
              mediaFolder,
              mediaFiles,
              artist,
              songTitle,
              embargo,
            };
            const result = onChange(modelFields);
            value = result?.distributor ?? value;
          }
          if (errors.distributor?.hasError) {
            runValidationTasks("distributor", value);
          }
          setDistributor(value);
        }}
        onBlur={() => runValidationTasks("distributor", distributor)}
        errorMessage={errors.distributor?.errorMessage}
        hasError={errors.distributor?.hasError}
        {...getOverrideProps(overrides, "distributor")}
      ></TextField>
      <RadioGroupField
        label="Media shared via:"
        name="mediaShared"
        isReadOnly={false}
        descriptiveText="Media to include your music video(s), related metadata and any static images you would like to be considered for promotional usage. How will you be sharing your media files?"
        isRequired={false}
        value={mediaShared}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              email,
              distributor,
              mediaShared: value,
              mediaFolder,
              mediaFiles,
              artist,
              songTitle,
              embargo,
            };
            const result = onChange(modelFields);
            value = result?.mediaShared ?? value;
          }
          if (errors.mediaShared?.hasError) {
            runValidationTasks("mediaShared", value);
          }
          setMediaShared(value);
        }}
        onBlur={() => runValidationTasks("mediaShared", mediaShared)}
        errorMessage={errors.mediaShared?.errorMessage}
        hasError={errors.mediaShared?.hasError}
        {...getOverrideProps(overrides, "mediaShared")}
      >
        <Radio
          children="Link to media folder"
          value="Link to media folder"
          {...getOverrideProps(overrides, "mediaSharedRadio0")}
        ></Radio>
        <Radio
          children="Media upload"
          value="Media upload"
          {...getOverrideProps(overrides, "mediaSharedRadio1")}
        ></Radio>
      </RadioGroupField>
      <TextField
        label="Link to media folder"
        descriptiveText="eg. DropBox, Hightail, Google Drive....etc"
        isRequired={false}
        isReadOnly={false}
        placeholder="https://dropbox.com/my-media-folder/"
        value={mediaFolder}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              email,
              distributor,
              mediaShared,
              mediaFolder: value,
              mediaFiles,
              artist,
              songTitle,
              embargo,
            };
            const result = onChange(modelFields);
            value = result?.mediaFolder ?? value;
          }
          if (errors.mediaFolder?.hasError) {
            runValidationTasks("mediaFolder", value);
          }
          setMediaFolder(value);
        }}
        onBlur={() => runValidationTasks("mediaFolder", mediaFolder)}
        errorMessage={errors.mediaFolder?.errorMessage}
        hasError={errors.mediaFolder?.hasError}
        {...getOverrideProps(overrides, "mediaFolder")}
      ></TextField>
      <Field
        errorMessage={errors.mediaFiles?.errorMessage}
        hasError={errors.mediaFiles?.hasError}
        label={"Media Files"}
        isRequired={false}
        isReadOnly={false}
      >
        <StorageManager
          onUploadSuccess={({ key }) => {
            setMediaFiles((prev) => {
              let value = key;
              if (onChange) {
                const modelFields = {
                  name,
                  email,
                  distributor,
                  mediaShared,
                  mediaFolder,
                  mediaFiles: value,
                  artist,
                  songTitle,
                  embargo,
                };
                const result = onChange(modelFields);
                value = result?.mediaFiles ?? value;
              }
              if (prev && prev !== undefined) {
                value = value + ',' + prev;
              }
              return value;
            });
          }}
          onFileRemove={({ key }) => {
            setMediaFiles((prev) => {
              const fileArray = prev.split(',');
              let i = 0;
              fileArray.forEach((remove) => {
                if (remove.includes(key)) {
                  fileArray.splice(i, 1);
                  Storage.remove(remove, { level: 'public' });
                }
                i++;
              });
              prev = fileArray.toString().replace(/^,|,$/g, '');

              let value = initialValues?.mediaFiles;
              if (onChange) {
                const modelFields = {
                  name,
                  email,
                  distributor,
                  mediaShared,
                  mediaFolder,
                  mediaFiles: value,
                  artist,
                  songTitle,
                  embargo,
                };
                const result = onChange(modelFields);
                value = result?.mediaFiles ?? value;
              }
              // return value;
              return prev;
            });
          }}
          processFile={processFile}
          accessLevel={"public"}
          acceptedFileTypes={[
            "audio/*",
            "video/*",
            "image/*",
            ".pdf",
            ".csv",
            ".doc",
            ". docx",
            ". xlsx",
          ]}
          isResumable={false}
          showThumbnails={true}
          maxFileCount={100}
          key={resetFile}
          {...getOverrideProps(overrides, "mediaFiles")}
        ></StorageManager>
      </Field>
      <TextAreaField
        label="Artists uploaded (separated by commas)"
        isRequired={false}
        isReadOnly={false}
        placeholder="Artist1, Artist2, ..."
        value={artist}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              email,
              distributor,
              mediaShared,
              mediaFolder,
              mediaFiles,
              artist: value,
              songTitle,
              embargo,
            };
            const result = onChange(modelFields);
            value = result?.artist ?? value;
          }
          if (errors.artist?.hasError) {
            runValidationTasks("artist", value);
          }
          setArtist(value);
        }}
        onBlur={() => runValidationTasks("artist", artist)}
        errorMessage={errors.artist?.errorMessage}
        hasError={errors.artist?.hasError}
        {...getOverrideProps(overrides, "artist")}
      ></TextAreaField>
      <TextAreaField
        label="Song titles uploaded (separated by commas)"
        isRequired={false}
        isReadOnly={false}
        placeholder="Song Title 1, Song Title 2, ..."
        value={songTitle}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              email,
              distributor,
              mediaShared,
              mediaFolder,
              mediaFiles,
              artist,
              songTitle: value,
              embargo,
            };
            const result = onChange(modelFields);
            value = result?.songTitle ?? value;
          }
          if (errors.songTitle?.hasError) {
            runValidationTasks("songTitle", value);
          }
          setSongTitle(value);
        }}
        onBlur={() => runValidationTasks("songTitle", songTitle)}
        errorMessage={errors.songTitle?.errorMessage}
        hasError={errors.songTitle?.hasError}
        {...getOverrideProps(overrides, "songTitle")}
      ></TextAreaField>
      <TextAreaField
        label="Embargo Information"
        isRequired={false}
        isReadOnly={false}
        value={embargo}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              email,
              distributor,
              mediaShared,
              mediaFolder,
              mediaFiles,
              artist,
              songTitle,
              embargo: value,
            };
            const result = onChange(modelFields);
            value = result?.embargo ?? value;
          }
          if (errors.embargo?.hasError) {
            runValidationTasks("embargo", value);
          }
          setEmbargo(value);
        }}
        onBlur={() => runValidationTasks("embargo", embargo)}
        errorMessage={errors.embargo?.errorMessage}
        hasError={errors.embargo?.hasError}
        {...getOverrideProps(overrides, "embargo")}
      ></TextAreaField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
            resetFiles();
            goToTop();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
